(function () {
  const selectors = {
    modal: '[data-nazva-notify-modal]',
    open: '[data-nazva-notify-open]',
    close: '[data-nazva-notify-close]',
    form: '[data-nazva-notify-form]',
    panel: '[data-nazva-notify-form-panel]',
    thanks: '[data-nazva-notify-thanks]',
    error: '[data-nazva-notify-error]',
    productInput: '[data-nazva-notify-product-input]',
    variantInput: '[data-nazva-notify-variant-input]',
    urlInput: '[data-nazva-notify-url-input]',
    messageInput: '[data-nazva-notify-message-input]',
  };

  const modal = document.querySelector(selectors.modal);
  if (!modal) return;

  const form = modal.querySelector(selectors.form);
  const formPanel = modal.querySelector(selectors.panel);
  const thanksPanel = modal.querySelector(selectors.thanks);
  const errorMessage = modal.querySelector(selectors.error);
  const productInput = modal.querySelector(selectors.productInput);
  const variantInput = modal.querySelector(selectors.variantInput);
  const urlInput = modal.querySelector(selectors.urlInput);
  const messageInput = modal.querySelector(selectors.messageInput);

  function getProductTitle(button) {
    return (
      button.dataset.productTitle ||
      document.querySelector('.product__title h1, .product__title, h1')?.textContent?.trim() ||
      ''
    );
  }

  function getVariantId(button) {
    return (
      button.closest('product-form')?.querySelector('[name="id"]')?.value ||
      button.dataset.variantId ||
      document.querySelector('product-form [name="id"]')?.value ||
      ''
    );
  }

  function openModal(button) {
    const productTitle = getProductTitle(button);
    const productUrl = button.dataset.productUrl || window.location.href;
    const variantId = getVariantId(button);

    if (form) form.reset();
    productInput.value = productTitle;
    variantInput.value = variantId;
    urlInput.value = productUrl;
    messageInput.value = [
      'Back in stock request',
      productTitle ? `Product: ${productTitle}` : '',
      variantId ? `Variant ID: ${variantId}` : '',
      productUrl ? `URL: ${productUrl}` : '',
    ]
      .filter(Boolean)
      .join('\n');

    if (errorMessage) errorMessage.hidden = true;
    formPanel.hidden = false;
    thanksPanel.hidden = true;
    modal.hidden = false;
    document.documentElement.classList.add('nazva-notify-modal-open');
    modal.querySelector('.nazva-notify-modal__dialog')?.focus();
  }

  function closeModal() {
    modal.hidden = true;
    document.documentElement.classList.remove('nazva-notify-modal-open');
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(selectors.open);
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      openModal(button);
    },
    true
  );

  modal.addEventListener('click', (event) => {
    if (event.target.closest(selectors.close)) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) closeModal();
  });

  form?.addEventListener('submit', (event) => {
    event.preventDefault();
    if (errorMessage) errorMessage.hidden = true;

    const submitButton = form.querySelector('[type="submit"]');
    submitButton?.setAttribute('disabled', 'disabled');

    fetch(form.action || window.location.href, {
      method: 'POST',
      body: new FormData(form),
      headers: {
        Accept: 'text/html',
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error('Back in stock form failed');
        formPanel.hidden = true;
        thanksPanel.hidden = false;
      })
      .catch(() => {
        if (errorMessage) errorMessage.hidden = false;
      })
      .finally(() => {
        submitButton?.removeAttribute('disabled');
      });
  });
})();
